import { Directive, HostListener, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { DeviceDetectService } from '@services/device-detect.service';
import { ToastService } from '@services/toast.service';

@Directive({
    selector: '[pnToast]',
    standalone: true,
})
export class ToastDirective {
    private device =  inject(DeviceDetectService);
    private toastService =  inject(ToastService);
    public isMobile = toSignal(this.device.isMobile());

    @HostListener('click', ['$event'])
    onClick() {
        if (this.isMobile()) {
            this.toastService.clear();
        }
    }
}
